var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","nudge-bottom":12},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"primary","text":""},on:{"click":function($event){$event.stopPropagation();}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"large":""}},[_vm._v("\n        mdi-menu-open\n      ")])],1)]}}])},[_c('v-card',[_c('v-list',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }